import styled from 'styled-components'
import { device } from '../responsive/deviceSizes'

const PageResolutions = styled.div`

  @media ${device.laptop} {
    max-width: 800px;
  }

  @media ${device.desktop} {
    max-width: 1400px;
  }
`

export default PageResolutions
